import { z } from 'zod';
import { apiClient } from './client';
import { battleCreatePayload, battleSchema, battleSnapshotSchema } from './battle-contract';
import { createCampaignQuestionLoader, type CampaignQuestion } from './campaign-question';
import { questionDifficultyApi } from './question-difficulty';

const loadOptions = createCampaignQuestionLoader(
  (id) => apiClient.questions.getById(id),
  async (ids) =>
    z
      .object({ data: z.array(z.object({ id: z.string(), name: z.string() })) })
      .parse(await apiClient.titles.getByIds({ ids })),
);
export const battlesApi = {
  create: async (kinds: readonly string[], displayName?: string) =>
    battleSchema.parse(await apiClient.battles.create({ ...battleCreatePayload(kinds), displayName })),
  get: async (code: string) => battleSchema.parse(await apiClient.battles.getByCode(code)),
  join: async (code: string, displayName?: string) =>
    battleSchema.parse(await apiClient.battles.join(code, { displayName })),
  snapshot: async (code: string) => battleSnapshotSchema.parse(await apiClient.battles.getSnapshot(code)),
  difficulty: (id: string) => questionDifficultyApi.get(id),
  async question(source: CampaignQuestion) {
    const result = await loadOptions(source.id, source.kind, source);
    return { ...result.question, options: result.options };
  },
};
